<template>
  <div>
    <v-row>
      <v-col cols="2" class="side-bar">
        <div class="page-title">
          Dashboard
        </div>
        <div class="nav">
          <div class="nav-link">
            <router-link to="/">Overzichtspagina</router-link>
          </div>
        </div>
      </v-col>
      <v-col cols="10">
        <div><Menu /></div>
        <template v-if="indicator && !indicator2">
          <v-row no-gutters dense>
            <v-col cols="12" md="5">
              <div class="title-container">
                <span class="main-title"> {{ indicator.omschrijving }} </span>
                <span class="sub-title" v-if="normalization != 'none'">
                  per inwoner
                </span>
                <span class="sub-title"> per {{ aggregation }} </span>
              </div>
            </v-col>
            <v-col cols="12" md="7">
              <div class="description">{{ indicator.beschrijving }}</div>
            </v-col>
          </v-row>
          <v-row no-gutters dense>
            <v-col cols="12" md="5">
              <Map :values="values" :normalization="normalization" />
            </v-col>
            <v-col cols="12" md="7">
              <BarChart :values="values" />
              <div class="analysis" v-if="indicator">
                {{ indicator.analyse }}
              </div>
            </v-col>
          </v-row>
        </template>
        <template v-if="indicator && indicator2">
          <v-row no-gutters dense>
            <v-col cols="12" md="6">
              <div class="title-container">
                <span class="main-title"> {{ indicator.omschrijving }} </span>
                <span class="sub-title" v-if="normalization != 'none'">
                  per inwoner
                </span>
                <span class="sub-title"> per {{ aggregation }} </span>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="title-container">
                <span class="main-title"> {{ indicator2.omschrijving }} </span>
                <span class="sub-title" v-if="normalization != 'none'">
                  per inwoner
                </span>
                <span class="sub-title"> per {{ aggregation }} </span>
              </div>
            </v-col>
          </v-row>
          <v-row no-gutters dense>
            <v-col cols="12" md="6">
              <div class="description">{{ indicator.beschrijving }}</div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="description">{{ indicator2.beschrijving }}</div>
            </v-col>
          </v-row>
          <v-row no-gutters dense>
            <v-col cols="12" md="6">
              <Map :values="values" :normalization="normalization" />
            </v-col>
            <v-col cols="12" md="6">
              <Map :values="values2" :normalization="normalization" />
            </v-col>
          </v-row>
          <v-row no-gutters dense>
            <v-col cols="12" md="6">
              <BarChart :values="values" />
              <div class="analysis" v-if="indicator">
                {{ indicator.analyse }}
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <BarChart :values="values2" />
              <div class="analysis" v-if="indicator">
                {{ indicator2.analyse }}
              </div>
            </v-col>
          </v-row>
        </template>
        <v-row>
          <v-col cols="12">
            <div id="data-table">
              <RawDataTable />
            </div>
          </v-col>
        </v-row>
        <div class="content-title">
          <a :href="justificationDocUrl" target="_blank"
            >Verantwoording indicatoren (PDF)</a
          >
        </div>
        <div class="spacing"></div>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Menu from "@/components/Menu";
import Map from "@/components/Map";
import BarChart from "@/components/BarChart";
import RawDataTable from "@/components/RawDataTable";

export default {
  name: "Dashboard",

  components: {
    Menu,
    Map,
    BarChart,
    RawDataTable
  },

  data: () => ({
    //
  }),
  computed: {
    indicator() {
      return this.$store.getters.indicator;
    },
    indicator2() {
      return this.$store.getters.indicator2;
    },
    values() {
      return this.$store.getters.values;
    },
    values2() {
      return this.$store.getters.values2;
    },
    normalization() {
      return this.$store.getters.normalization;
    },
    aggregation() {
      return this.$store.getters.aggregation;
    },
    justificationDocUrl() {
      return `${process.env.VUE_APP_DATA_DIR}data/${process.env.VUE_APP_VERANTWOORDING_DOC}`;
    }
  }
};
</script>

<style lang="css" scoped>
.page-title {
  font-size: 1.2em;
  font-weight: bold;
  margin: 60px 5px;
}
.side-bar {
  background-color: #ededed;
}
.nav {
  margin: 0px 20px;
}
.nav-link {
  margin: 10px 0px;
}
.title-container {
  margin-left: 10px;
}
.main-title {
  font-size: 1.2em;
  font-weight: bold;
}
.sub-title {
  font-size: 1em;
}
.description {
  font-size: 0.9em;
  font-style: italic;
  margin-left: 10px;
}
.analysis {
  margin-top: 40px;
  padding: 0px 20px;
}
#data-table {
  padding: 20px;
  margin-bottom: 50px;
}
.content-title {
  padding: 0px 25px;
  font-weight: bold;
}
.spacing {
  height: 50px;
}
</style>
